/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Block from "../../atoms/layout/Block";
import {ShowHide} from "../../atoms/layout/ShowHide";
import {RemovableItem} from "../../atoms/RemovableItem";
import {SearchTypeAhead} from "../../molecules/finder/SearchTypeAhead";
import {Highlighter, Menu, MenuItem, TypeaheadMenu} from "react-bootstrap-typeahead";
import {matchProductWithSearch} from "../../../selectors/products";
import {withI18N} from "../../hoc/withI18N";


class _FinderTypeAhead extends React.Component {

    static propTypes = {
        placeholder: PropTypes.string,
        items: PropTypes.oneOfType([ PropTypes.array, PropTypes.object ]),
        setSearch: PropTypes.func,
        search: PropTypes.string,
        filter: PropTypes.func,
        renderMenu: PropTypes.func,
        emptyLabel: PropTypes.string
    };

    setSearch = (search) => {
        if (typeof search === "object" && search.id) {
            this.props.setSearch(`searchid:${search.id}`)
        } else if (typeof search === "string") {
            this.props.setSearch(search);
        }
    };

    setInputReference = (ref) => this.ref = ref;

    onPaginate = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (!this.ref) {
            return;
        }

        const instance = this.ref.getInstance();

        if (!instance) {
            return;
        }

        this.setSearch(instance.getInput() ? instance.getInput().value : "");
        instance.clear();
    };

    renderMenu = (results, menuProps) => {
        const search = this.ref && this.ref.getInstance() && this.ref.getInstance().getInput() && this.ref.getInstance().getInput().value;
        const items = [].concat(results)
            .sort((a, b) => b.searchWeight - a.searchWeight)
            .slice(0, 8);

        if (items.length === 0) {
            return <Menu {...menuProps} />
        }

        return <Menu {...menuProps}>
            {items.map((item, idx) => <MenuItem key={item.id} option={item} position={idx}>
                <Highlighter search={search}>
                    {item.referenceTitle || item.title}
                </Highlighter>
            </MenuItem>)}
            {
                results.length > 8 && [
                    <li key="divider" role="separator" className="divider" />,
                    <MenuItem option={{paginationOption: true}}>
                        {this.props.translate("Show all results")}
                    </MenuItem>
                ]
            }
        </Menu>;
    };

    render() {
        const { items, search, placeholder, filter, emptyLabel } = this.props;

        return <React.Fragment>
            <Block className="p-flex">
                <SearchTypeAhead items={items}
                                 renderMenu={this.renderMenu}
                                 emptyLabel={emptyLabel}
                                 setRef={this.setInputReference}
                                 onPaginate={this.onPaginate}
                                 filterBy={filter}
                                 placeholder={placeholder}
                                 onSelect={this.setSearch} />
            </Block>
            <Block className="selected__search">
                <ShowHide show={search}>
                    <RemovableItem label={search}
                                   className="search-item"
                                   remove={() => this.props.setSearch("")} />
                </ShowHide>
            </Block>
        </React.Fragment>
    }

}


export const FinderTypeAhead = withI18N(_FinderTypeAhead);
